export default __webpack_public_path__ + "src/images/packages/eco-karoo-lodge/7332abd8a1fe86e0068c3d0e21a5189f-2.png";